import {
  createBaseAsyncHandlers,
  createKeyedAsyncReducer,
  initialState,
} from '../../../redux-util/async-helpers';
import { GET_ADOPTION } from '../../bridge-methods';
import { createReducer } from '../../../redux-util/general-helpers';

const singleFetchBase = createBaseAsyncHandlers(
  GET_ADOPTION,
  () => 'OMITTED. USE THE ADOPTION LIST.'
);

export default createKeyedAsyncReducer({
  actionKeys: GET_ADOPTION,
  param: 'id',
  itemReducer: createReducer(initialState, singleFetchBase),
});
